var exports = {
  "U": "xfd349460--7911b8--arrow",
};

module.exports = exports;
